import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import Button from '../CustomButton/CustomButton';

class ConfirmButton extends Component {
  render() {
    return (
      <Button {...this.props} icon fill wd bsStyle="primary">
        <i className="fa fa-lg fa-check" />
        <FormattedMessage
          id="ids_confirm"/>
      </Button>
    );
  }
}

// {
//   /* <Button icon="times-circle-o" onClick={() => this.onCancel()}>
//     <FormattedMessage id='CollaboratorForm.Cancel' description="expense cancel button" defaultMessage="Annuler" />
//   </Button> <
//         Button icon onClick = {
//           () => this.onSubmit() } >
//         <i className="fa fa-floppy-o"></i> < FormattedMessage id = 'ids_save'
//         description = "expense save button"
//         defaultMessage = "Enregistrer" / >
//         <
//         /Button> */
// }

export { ConfirmButton };
